export default __webpack_public_path__ + "static/carousel-2-vittorio-6f59fa93d2210066fc6d29e84db729f2.png";